/**
 * Semantic linter rule for SoftBody3D: ports get_configuration_warnings
 * (soft_body_3d.cpp:401-407). MeshInstance3D adds no mesh warning
 * (visual_instance_3d.cpp), so the one check is a presence test on this node's
 * own `mesh` resource key, not a NodePath to resolve.
 */
import { ruleRegistry } from '../../../../linter/RuleRegistry.js';
import { descendsFromClass } from '../../../../godot/classdb/classBaseTypes.js';
import { resourceSlotIsEmpty } from '../../../../linter/resourceChecker.js';
import { armEmits, groundedArm, reportArm } from '../../../../linter/ruleArms.js';
const arms = {
    missingMesh: groundedArm('valid-softbody3d-mesh', { kind: 'configuration-warning' }),
};
function checkSoftBody3D(context) {
    const diagnostics = [];
    const { node } = context;
    if (resourceSlotIsEmpty(node.rawProperties.mesh)) {
        reportArm(diagnostics, arms.missingMesh, node, 'This body will be ignored until you set a mesh.');
    }
    return diagnostics;
}
const softBody3DValidationRule = {
    meta: {
        name: 'valid-softbody3d-mesh',
        description: "Warns when a SoftBody3D has no mesh set, matching Godot's own configuration warning",
        category: 'validation',
        applicableNodeTypeMatcher: (nodeType) => descendsFromClass(nodeType, 'SoftBody3D'),
        emits: armEmits(arms),
    },
    check: checkSoftBody3D,
};
ruleRegistry.register(softBody3DValidationRule);
// Export for testing
//# sourceMappingURL=linter.js.map